import * as React from "react"
import { UserType } from "../../types/user"
import {
  getUserTypeByUrl,
  getUserTypeByUrlV2
} from "../../util/getUserTypeByUrl"
import useConfig from "../useConfig"

export const useLocalUserType = () => {
  const { platformName } = useConfig()
  const userTypeFromUrl = getUserTypeByUrlV2()

  const isModerator = React.useMemo(
    () => userTypeFromUrl === UserType.MODERATOR,
    [userTypeFromUrl]
  )

  const isAudience = React.useMemo(() => {
    return userTypeFromUrl === UserType?.AUDIENCE
  }, [userTypeFromUrl])

  const isBroadcaster = React.useMemo(() => {
    return userTypeFromUrl === UserType?.BROADCASTER
  }, [userTypeFromUrl])

  // HACK: the room url hiding feature in LM/Utta breaks the getUserTypeByUrl functions(s)
  // a proper fix would be to not check the url in the browser but instead check some room url state
  if (platformName === "LearnMachine" || platformName === "Utta")
    return { isAudience: false, isBroadcaster: false, isModerator: true }
  return { isAudience, isBroadcaster, isModerator }
}
